import { tss } from 'tss-react/mui';

export const useNavBarStyles = tss.withName('NavBar').create(({ theme }) => ({
    appBar: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 40,
        transition: 'background-color 0.4s ease, border-color 0.4s ease, backdrop-filter 0.4s ease',
        borderBottom: '1px solid transparent',
    },
    appBarSolid: {
        backgroundColor: 'rgba(245, 245, 242, 0.92)',
        backdropFilter: 'blur(12px)',
        borderBottom: `1px solid ${theme.palette.divider}`,
    },
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        maxWidth: '1400px',
        width: '100%',
        margin: '0 auto',
        padding: theme.spacing(2.5, '6%'),
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2, '6%'),
        },
    },
    logo: {
        fontSize: '1.15rem',
        fontWeight: 600,
        letterSpacing: '-0.01em',
        cursor: 'pointer',
        color: 'inherit',
        transition: 'color 0.3s ease',
    },
    desktopNav: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'flex',
            alignItems: 'center',
            gap: theme.spacing(5),
        },
    },
    navLink: {
        fontSize: '0.9rem',
        fontWeight: 500,
        textDecoration: 'none',
        color: 'inherit',
        position: 'relative',
        paddingBottom: 4,
        '&::after': {
            content: '""',
            position: 'absolute',
            left: 0,
            bottom: 0,
            width: '100%',
            height: 1,
            backgroundColor: 'currentColor',
            transform: 'scaleX(0)',
            transformOrigin: 'left',
            transition: 'transform 0.3s ease',
        },
        '&:hover::after': {
            transform: 'scaleX(1)',
        },
    },
    ctaButton: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'inline-flex',
        },
    },
    menuButton: {
        display: 'flex',
        color: 'inherit',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
}));
